// 'use client';
// import React from 'react';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import BlogCard from './BlogCard';
// import Link from 'next/link';

// const Blog = ({ blogs }: any) => {
//   return (
//     <section className="blog padding-top padding-bottom-style2">
//       <div className="container">
//         <div className="section-header d-md-flex align-items-center justify-content-between">
//           <div className="section-header__content">
//             <h2>Regular articles</h2>
//           </div>
//           <div className="product-btn order-sm-2 order-lg-3">
//             <Link className="trk-btn" href="/hot-deals">
//               View all
//             </Link>
//           </div>
//         </div>
//         <div className="blog__wrapper">
//           <div className="blog__slider">
//             {blogs?.data?.posts?.length > 0 ? (
//               <Swiper
//                 spaceBetween={12}
//                 slidesPerView={1.2}
//                 breakpoints={{
//                   576: {
//                     slidesPerView: 1.5,
//                   },
//                   768: {
//                     slidesPerView: 2,
//                   },
//                   992: {
//                     slidesPerView: 3,
//                     spaceBetween: 24,
//                   },
//                   1200: {
//                     slidesPerView: 3,
//                   },
//                 }}
//               >
//                 {blogs?.data?.posts?.map((item: any, index: number) => (
//                   <SwiperSlide key={index}>
//                     <BlogCard item={item} />
//                   </SwiperSlide>
//                 ))}
//               </Swiper>
//             ) : (
//               <p>No blog found </p>
//             )}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Blog;

// src/features/blog/regular-articles/components/Blog.tsx

// NO 'use client' here. This is a Server Component.
'use client';
import Link from 'next/link';
// import { fetcher } from '@/lib/fetcher';
import { BlogSlider } from './BlogSlider'; // Import the new client component
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import { BannerSkeleton } from '@/features/home/banner/components/BannerSkeleton';
import { API_BLOGS } from '@/constant/apiRout';

// This component is now ASYNC and takes NO PROPS
const Blog = () => {
  // ✅ DATA IS FETCHED HERE, INSIDE THE COMPONENT
  const { data: blogs, isLoading } = useFetcherCSR(API_BLOGS);
  const posts = blogs?.data?.posts ?? [];

  if (isLoading) {
    return <BannerSkeleton />;
  }

  return (
    <section className="blog padding-top padding-bottom-style2">
      <div className="container">
        {/* This header is now static HTML rendered on the server */}
        <div className="section-header d-md-flex align-items-center justify-content-between">
          <div className="section-header__content">
            <h2>Regular articles</h2>
          </div>
          <div className="product-btn order-sm-2 order-lg-3">
            <Link className="trk-btn" href="/blogs">
              View all
            </Link>
          </div>
        </div>
        <div className="blog__wrapper">
          <div className="blog__slider">
            {/* Pass the server-fetched data to our client slider component */}
            <BlogSlider posts={posts} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blog;
